import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ITripsOverviewColumn } from '../interfaces';
import LoaderService from '../../../Services/LoaderService';

import useFilter from '../hooks/useFilter';

import RangeDurationFilter from '../Filter/RangeDurationFilter';
import TooltipComponent from '../../TooltipComponent';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { DURATION_KEY } from '../constants';
import { columnsAtom, rideBookFilterAtom } from '../TripsOverviewState';
import { getDataForFilter } from '../TripsOverviewService';
import useAnalytics from '../../../hooks/useAnalytics';

interface IThDurationProps {
  id: string;
}

function ThDuration(props: IThDurationProps): JSX.Element {
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);
  const [tableActionsFilters, setTableActionsFilters] = useRecoilState(
    rideBookFilterAtom(props.id)
  );
  const { formatMessage: f } = useIntl();

  const { updateFilterItemsState } = useFilter();
  const { trackEvent } = useAnalytics();

  const getFilterData = async () => {
    LoaderService.showLoader(true);
    const dataForFilter = await getDataForFilter(DURATION_KEY);

    if (dataForFilter) {
      updateFilterItemsState([
        { id: props.id, isOpen: true, isActionChipsOpen: false, data: dataForFilter, values: null },
      ]);

      LoaderService.showLoader(false);
    } else {
      LoaderService.showLoader(false);
    }
  };

  const handleOnClick = (event: any) => {
    event.preventDefault();
    const { id } = event.target;
    trackEvent(['ride book', 'click', `Ride book open filter ${id}`]);

    setTableActionsFilters(
      (tableActionFilter) =>
        tableActionFilter && {
          ...tableActionFilter,
          id: props.id,
          isOpen: true,
          isActionChipsOpen: false,
        }
    );

    if (id) {
      if (!tableActionsFilters) {
        getFilterData();
      }
    }
  };

  return (
    <div
      className={`th-sticky b-table-actions ${
        tableActionsFilters && tableActionsFilters.values ? 'active' : ''
      }`}
      style={{
        minWidth: '180px',
        flex: 1,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'ridePlayer.selectRidesModal.table.duration',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.duration',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, props.id)}
      >
        <div className="d-flex w-100">
          <div
            className="text-truncate"
            id={props.id}
            onClick={handleOnClick}
            data-cy={`filter-button-text-${props.id}`}
          >
            {f({ id: 'ridePlayer.selectRidesModal.table.duration' })}
          </div>

          <a
            href="#"
            className="filter cmd-icons cmd-icon-filter"
            id={props.id}
            onClick={handleOnClick}
            data-cy={`filter-button-${props.id}`}
          >
            {/* test */}
          </a>
          <div />
        </div>
      </TooltipComponent>{' '}
      {tableActionsFilters &&
        tableActionsFilters.isOpen &&
        !tableActionsFilters.isActionChipsOpen &&
        tableActionsFilters.data && (
          <div id="range-select" style={{ position: 'absolute', left: '0', top: '50px' }}>
            <RangeDurationFilter id={props.id} />
          </div>
        )}
    </div>
  );
}

export default ThDuration;
